import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

/**
 * Maneja las respuestas de sesión del ws de Minerva para el token externo del login:
 * - 428 MUST_CHANGE_PASSWORD → perfil con el diálogo de cambio de contraseña
 * - 401, o 404 "Debe loguearse primero" (petición sin token) → la sesión de Minerva se cerró
 *   (sesión única por usuario, cambio de clave): volver al login
 * No toca los tokens propios de otros módulos (ej. el login aparte de boleteo).
 */
export const minervaSessionInterceptor: HttpInterceptorFn = (req, next) => {
  const isMinerva = req.url.startsWith(environment.externalWsUrl) || req.url.startsWith(environment.externalApiUrl);
  if (!isMinerva) {
    return next(req);
  }

  const auth = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const header = req.headers.get('Authorization');
      const usesLoginToken = !header || header === `Bearer ${auth.externalToken()}`;
      const noTokenError = error.status === 404 && /debe loguearse/i.test(error.error?.message ?? '');
      if (auth.isAuthenticated() && usesLoginToken && !req.url.includes('/login/change-password')) {
        if (error.status === 428) {
          router.navigate(['/profile'], { queryParams: { changePassword: 1 } });
        } else if (error.status === 401 || noTokenError) {
          auth.clearSession('session-closed');
        }
      }
      return throwError(() => error);
    }),
  );
};
